<script>
export default {
  name: 'FourDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6933 5.87342C12.7831 5.87342 13.6666 4.98993 13.6666 3.90009C13.6666 2.81025 12.7831 1.92676 11.6933 1.92676C10.6035 1.92676 9.71997 2.81025 9.71997 3.90009C9.71997 4.98993 10.6035 5.87342 11.6933 5.87342Z"
      :fill="color"
    />
    <path
      d="M4.30671 5.87342C5.39655 5.87342 6.28004 4.98993 6.28004 3.90009C6.28004 2.81025 5.39655 1.92676 4.30671 1.92676C3.21687 1.92676 2.33337 2.81025 2.33337 3.90009C2.33337 4.98993 3.21687 5.87342 4.30671 5.87342Z"
      :fill="color"
    />
    <path
      d="M11.6933 14.0736C12.7831 14.0736 13.6666 13.1901 13.6666 12.1003C13.6666 11.0104 12.7831 10.127 11.6933 10.127C10.6035 10.127 9.71997 11.0104 9.71997 12.1003C9.71997 13.1901 10.6035 14.0736 11.6933 14.0736Z"
      :fill="color"
    />
    <path
      d="M4.30671 14.0736C5.39655 14.0736 6.28004 13.1901 6.28004 12.1003C6.28004 11.0104 5.39655 10.127 4.30671 10.127C3.21687 10.127 2.33337 11.0104 2.33337 12.1003C2.33337 13.1901 3.21687 14.0736 4.30671 14.0736Z"
      :fill="color"
    />
  </svg>
</template>
